import { z } from 'zod';
/** turnier.de federation/competition GUID (as in the clubs.aspx `id=` param). */
export const federationId = z.string().trim().min(8).max(100);
export const turnierDeClubQuery = z.object({
    federationId,
    q: z.string().trim().max(120).optional(),
});
export const connectTurnierDeRequest = z.object({
    federationId,
    externalClubId: z.string().trim().min(1).max(60),
    externalClubUrl: z.string().trim().url().max(500).optional(),
    clubName: z.string().trim().max(200).optional(),
});
export const setTurnierDeSyncIntervalRequest = z.object({
    /** Minutes between automatic match syncs; null disables it. */
    minutes: z.number().int().min(60).max(10_080).nullable(),
});
//# sourceMappingURL=turnier-de.js.map